/**
 *
 * Teams Integration
 *
 */

import React, { memo } from 'react';

import { useIntegrationsContext } from 'containers/Setup/Integrations/context/context';

import { CreateTeams } from './Components/CreateTeams';
import { EditTeams } from './Components/EditTeams';
import { TeamsTable } from './Components/TeamsTable';

export const Teams = memo(() => {
  const { isOpen, actionType } = useIntegrationsContext();

  return isOpen ? (
    actionType === 'Add' ? (
      <CreateTeams />
    ) : (
      <EditTeams />
    )
  ) : (
    <TeamsTable />
  );
});
